import { Injectable } from '@angular/core';
import { Apollo } from 'apollo-angular';
import { TaskFileInterface } from './definitions/task-file-interface';
import { Observable } from 'rxjs';
import { ErrorsInterface } from '../errors/errors-interface';
import { DocumentNode } from 'graphql';
import { FetchResult } from '@apollo/client/core';

interface RemoveFileTaskResponse {
  taskFile: {
    remove: {
      output: TaskFileInterface;
      errors: ErrorsInterface;
    };
  };
}

@Injectable()
export class RemoveTaskFileService {
  constructor(private apollo: Apollo) {}

  removeTaskFile(
    taskFileId: string,
    mutation: DocumentNode
  ): Observable<FetchResult<RemoveFileTaskResponse>> {
    return this.apollo.mutate<RemoveFileTaskResponse>({
      mutation: mutation,
      variables: {
        taskFileId: taskFileId,
      },
    });
  }
}
